import { z } from 'zod';
import { RoleCode } from '../../enums/enum.js';
const baseUser = z.object({
    id: z.number(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    createdOn: z.string(),
    idFromPlatform: z.string(),
});
const internalAdminUser = baseUser.extend({
    roleCode: z.enum(RoleCode).nullable(),
});
const userWithAllRoles = baseUser.extend({
    storeUserRoles: z.array(z.object({
        id: z.number(),
        roleCode: z.enum(RoleCode),
        storeId: z.number(),
        storeName: z.string(),
    })),
    organizationUserRoles: z.array(z.object({
        id: z.number(),
        roleCode: z.enum(RoleCode),
        organizationId: z.number(),
        organizationName: z.string(),
    })),
});
export const commandUser = {
    base: baseUser,
    baseWithAllRoles: userWithAllRoles,
    internalAdmin: internalAdminUser,
};
//# sourceMappingURL=user.js.map